var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.975 13.4246H35.025C36.886 13.4246 38.4 14.9386 38.4 16.7996V31.1996C38.4 33.0605 36.886 34.5746 35.025 34.5746H12.975C11.114 34.5746 9.60003 33.0605 9.60003 31.1996V16.7996C9.60003 14.9386 11.114 13.4246 12.975 13.4246ZM11.85 31.1996C11.85 31.8199 12.3547 32.3246 12.975 32.3246H35.025C35.6453 32.3246 36.15 31.8199 36.15 31.1996V16.7996C36.15 16.1792 35.6453 15.6746 35.025 15.6746H12.975C12.3547 15.6746 11.85 16.1792 11.85 16.7996V31.1996Z",
    fill: "#EA9E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.041 14.8274L24 23.7226L35.959 14.8274L37.3019 16.6327L24 26.5268L10.6981 16.6327L12.041 14.8274Z",
    fill: "#EA9E1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.8,
    height: 28.8,
    fill: "white",
    transform: "matrix(-1 0 0 1 38.4 9.59961)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.c91004138bc4847cf49066063385fca4.svg";
export { ForwardRef as ReactComponent };